import React from 'react'
import { cn } from '@/lib/utils'

const ANCHOR_ICON_URL =
  'https://cdn.magicpatterns.com/uploads/tFkm6Yrwf58Qy45u456YzX/Ask_Anchor.svg'

export function AnchorIcon({ className }) {
  return (
    <div
      className={cn('h-4 w-4 shrink-0', className)}
      style={{
        WebkitMaskImage: `url(${ANCHOR_ICON_URL})`,
        maskImage: `url(${ANCHOR_ICON_URL})`,
        WebkitMaskSize: '115%',
        maskSize: '115%',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center 45%',
        maskPosition: 'center 45%',
        backgroundColor: 'currentColor',
      }}
    />
  )
}
